import emptyFunction from 'react-utils/emptyFunction';
import { shouldRightAlignProperty } from '../../utils/shouldRightAlignProperty';
import TruncateDiv from '../TruncateDiv';
import PropertyCellDisplayContent from './PropertyCellDisplayContent';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyCell = ({
  value,
  objectTypeId,
  objectId,
  propertyDefinition,
  canEditObject,
  getSecondaryPropertyValue,
  onPropertyUpdatesSucceeded = emptyFunction,
  onPropertyUpdatesFailed = emptyFunction,
  requiredCellProps
}) => /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
  children: /*#__PURE__*/_jsx(TruncateDiv, {
    rightAligned: shouldRightAlignProperty(propertyDefinition),
    children: /*#__PURE__*/_jsx(PropertyCellDisplayContent, {
      value: value,
      objectId: objectId,
      objectTypeId: objectTypeId,
      propertyDefinition: propertyDefinition,
      canEditObject: canEditObject,
      getSecondaryPropertyValue: getSecondaryPropertyValue,
      onPropertyUpdatesSucceeded: onPropertyUpdatesSucceeded,
      onPropertyUpdatesFailed: onPropertyUpdatesFailed
    })
  })
}));
export default PropertyCell;